import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import clientBackend from "configurations/axios";
import { apiKey } from "configurations/constant";
import { notNull } from "utils/checkInputs";
import { getSub } from "redux/actions/userActions";
import {
  SISTEMA_CONTABLE_DASHBOARD_RESOURCE,
  SISTEMA_CONTABLE_MODULE_ID,
} from "../constants";

const getPermisosModulo = (idPerfil, codigoSistema, codigoModulo) =>
  `/admin/permisos/modulo/${idPerfil}/${codigoSistema}/${codigoModulo}`;

const normalizePermissons = (data) => (Array.isArray(data) ? data : []);

/**
 * Permisos del modulo contable (modulo 5). Se guardan en estado local para no
 * mezclarlos con los permisos del menu de facturacion (state.resources).
 */
export default function usePermisosContable() {
  let tokenUser = useSelector((state) => state.user.tk);
  tokenUser = notNull(tokenUser) ? tokenUser : "";

  const navigate = useNavigate();
  const [permissions, setPermissions] = useState([]);

  const updatePermissons = useCallback(() => {
    clientBackend
      .get(getPermisosModulo(getSub(tokenUser), apiKey, SISTEMA_CONTABLE_MODULE_ID))
      .then((result) => {
        let menuPermissons = normalizePermissons(result.data).filter(
          (item) => item.menuPadre !== "CFG" && item.id !== "CFG",
        );
        if (menuPermissons.length === 0) {
          menuPermissons = [SISTEMA_CONTABLE_DASHBOARD_RESOURCE];
        }
        setPermissions(menuPermissons);
      })
      .catch(() => navigate("/"));
  }, [tokenUser, navigate]);

  return {
    permissions,
    updatePermissons,
  };
}
